"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThankyouComponent = void 0;
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var _services_1 = require("@/_services");
var ThankyouComponent = /** @class */ (function () {
    function ThankyouComponent(authenticationService, userService, route, router) {
        this.authenticationService = authenticationService;
        this.userService = userService;
        this.route = route;
        this.router = router;
        this.currentUser = this.authenticationService.currentUserValue;
    }
    ThankyouComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.paramMap.subscribe(function (params) {
            _this.type = params.get('type');
            _this.registeredEmail = localStorage.getItem('registeredEmail');
            _this.resetEmail = localStorage.getItem('resetEmail');
        });
        if (this.type == "reg") {
            this.messageType = "Register";
        }
        else {
            this.messageType = "Reset";
        }
    };
    ThankyouComponent = __decorate([
        core_1.Component({ template: require('./thankyou.component.html') }),
        __metadata("design:paramtypes", [_services_1.AuthenticationService,
            _services_1.UserService,
            router_1.ActivatedRoute,
            router_1.Router])
    ], ThankyouComponent);
    return ThankyouComponent;
}());
exports.ThankyouComponent = ThankyouComponent;
